export const decreaseTagValue = heading => {
  /** If no heading passed return default */
  if (!heading) return { value: 'H3' }
  const size = heading.value[1]
  const tagNumber = parseInt(size, 10) + 1
  // H5 is the max heading size available
  if (size === '5') {
    return heading
  }

  return { value: `H${tagNumber}` }
}
